const areas = {
  headerButtons: {
    create: {
      createBtn: 'Criar',
    },

    import: 'Importar',
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Type',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  toast: {
    error: {
      badResponse: '[Area] resposta inválida do servidor',
      create: {},
      edit: {},
      delete: '[Area] Não foi possível excluir',
    },
    success: {
      create: {
        default: 'Zona criada com sucesso',
      },
      edit: {},
      delete: {
        default: 'As zonas foram excluídas com sucesso',
      },
    },
  },
  create: {
    createBtn: 'Novo',
    successToast: {
      message: 'Sucesso! zona criada',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível criar zona',
      duplicateMessage: 'Já existe uma zona com o nome escolhido',
    },
    validations: {
      name: 'Campo de nomeação obrigatória',
      type: 'Inserir é obrigatório',
      siteId: 'ID do local é obrigatório',
    },
  },
  delete: {
    deleteBtn: 'Remover',
    deleteModal: {
      header: 'Excluir zonas?',
      body: 'Você está prestes a excluir {{number}} zonas',
    },
    successToast: {
      message: 'Excluído com sucesso!',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível excluir a zona',
    },
  },
  update: {
    successToast: {
      message: 'Sucesso! Atualizações de zona',
    },
    errorToast: {
      message: 'Ocorreu um erro! Não foi possível atualizar a zona',
    },
    validations: {
      name: 'Campo de nomeação obrigatória',
      type: 'Inserir é obrigatório',
    },
  },
  forms: {
    tabs: {
      general: 'Geral',
      advancedSettings: 'Configurações avançadas',
    },

    header: {
      createArea: {
        title: 'Criar',
      },

      updateArea: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalhes',
        fields: {
          showOtherAreas: 'Mostrar Outras zonas',
          name: 'Nome',
          type: 'Tipo',
        },
      },
      map: {
        header: 'Mapa',
      },
      settings: {
        btnAdd: 'Adicionar',
        header: 'Proporção',
        label: 'Escolher Proporção de zonas',
        notice: 'As proporções que contêm \'Todos\' estão associadas e podem ser editadas em todas as zonas.',
        headerAreaRestrictions: 'Restrições de zona',
        titleAreaRestrictions: 'Bloquear ações',
      },
      advancedSettings: {
        consistentPassengerRouting: {
          title: 'Roteamento Consistente de Passageiros',
          toolTipInformation:
            'Garante que o mesmo grupo de passageiros siga sempre a mesma rota de e para a zona, otimizando a eficiência da viagem e minimizando confusão.',
        },
        sameDriverForGroup: {
          title: 'Mesmo Motorista para o Grupo',
          toolTipInformation:
            'Atribui o mesmo motorista para transportar o grupo de passageiros tanto na coleta quanto na entrega, proporcionando familiaridade e consistência.',
        },
        overrideOptions: {
          bySystemSettings: 'Pelas Configurações do Sistema',
          enabled: 'Habilitado',
          disabled: 'Desabilitado',
        },
        tripBoardingTime: {
          title: 'Tempo de embarque',
          toolTipInformation:
            'O tempo necessário para pegar um passageiro em sua parada (este parâmetro impactará a duração total da viagem)',
        },
        waitForBoardingTime: {
          title: 'Tempo de espera para embarque',
          toolTipInformation: 'Ao chegar a uma parada, o motorista aguardará até o horário exato de embarque, se necessário.',
        },
        tripDropOffTime: {
          title: 'Tempo de desembarque',
          toolTipInformation:
            'O tempo necessário para deixar um passageiro em sua parada (este parâmetro impactará a duração total da viagem)',
        },
        maxDropOffEarly: {
          title: 'Máx. adiantado no desembarque',
          toolTipInformation:
            'Número máximo de minutos que um motorista pode chegar adiantado em relação ao horário de desembarque definido na reserva',
        },
        maxDropOffDelay: {
          title: 'Máx. atraso no desembarque',
          toolTipInformation:
            'Número máximo de minutos que um motorista pode chegar atrasado em relação ao horário de desembarque definido na reserva',
        },
        maxBoardingDelay: {
          title: 'Máx. atraso no embarque',
          toolTipInformation:
            'Número máximo de minutos que um motorista pode chegar atrasado em relação ao horário de embarque definido na reserva',
        },
        maxBoardingEarly: {
          title: 'Máx. adiantado no embarque',
          toolTipInformation:
            'Número máximo de minutos que um motorista pode chegar adiantado em relação ao horário de embarque definido na reserva',
        },
        maxTripDuration: {
          title: 'Máx. duração da viagem',
          toolTipInformation: 'Duração máxima de uma viagem em minutos',
        },
        maxSinglePassengerTime: {
          title: 'Máx. duração da viagem por passageiro',
          toolTipInformation: 'Duração máxima de uma viagem em minutos por passageiro',
        },
      },
    },
  },

  polygoneTypes: {
    operationalArea: 'Zona Operacional',
    fares: 'Tarifas',
    routes: 'Rotas',
    block: 'Bloquear',
  },
};

export default areas;
